import React, { useEffect, useState } from "react";
import Header from "../Layout/Header";
// import airFilter from "../../Images/airFilter.jpg";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  CircularProgress,
  Container,
  Grid,
  Typography,
  TextField,
  IconButton,
} from "@material-ui/core";
import Footer from "../Layout/Footer";
import { gpColors } from "../../constants/colors";
import Pagination from "@material-ui/lab/Pagination";
import usePagination from "./Pegination";
import airFilter from "../../Images/airFilter.jpg";
import SearchOutlined from "@material-ui/icons/SearchOutlined";
import { Helmet } from 'react-helmet'
const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    padding: "30px",
    position: "relative",
    marginTop: "75px",
    [theme.breakpoints.up("sm")]: {
      marginTop: "105px",
    },
  },
  filterHeader: {
    fontWeight: 900,
    fontSize: "20px",
    height: "53px",
    background: "#36404b",
    margin: "0px",
    lineHeight: "58px",
    letterSpacing: "1px",
    textAlign: "center",
    color: "#fff",
    position: "relative",
    width: "260px",
    marginBottom: "30px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&:before": {
      content: "''",
      left: "-20px",
      borderStyle: "solid",
      borderWidth: "0 0 53px 20px",
      borderColor: `transparent transparent ${gpColors.logoBrown} transparent`,
      position: "absolute",
    },
    "&:after": {
      content: "''",
      right: "-20px",
      borderStyle: "solid",
      borderWidth: "53px 20px 0 0",
      borderColor: `${gpColors.logoBrown} transparent transparent transparent`,
      position: "absolute",
    },
  },
  gridList: {
    borderBottom: "1px solid #ddd",
    paddingLeft: "10px",
    paddingRight: "5px",
    direction: "column",
    display: "flex",
    alignItems: "center",
  },
  img: {
    height: "100%",
    width: "65%",
    [theme.breakpoints.only("sm")]: {
      width: "30%",
    },
  },
  gridWrapper: {
    height: 195,
    width: "80%",
    borderLeft: "1px solid #ddd",
    borderRight: "1px solid #ddd",
    borderTop: "1px solid #ddd",
    //mobile view
    [theme.breakpoints.only("sm")]: {
      width: "100%",
      height: 230,
    },
    [theme.breakpoints.only("xs")]: {
      width: "100%",
      height: 230,
    },
  },
  filterContent: {
    fontSize: "16px",
    lineHeight: 2,
    textAlign: "justify",
    marginLeft: "50px",
    marginRight: "50px",
    [theme.breakpoints.down("md")]: {
      marginLeft: "0px",
      marginRight: "0px",
    },
  },
  imgBox: {
    width: "30%",
    height: 195,
    //mobile view
    [theme.breakpoints.only("xs")]: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
      height: "100%",
    },
    // ipad view
    [theme.breakpoints.only("sm")]: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
      height: "100%",
    },
  },
  elementContainer: {
    width: "100%",
    marginBottom: "10px",
    //mobile view
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
    //desktop view
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  changeRowColor: {
    // backgroundColor: "#ebecf0",
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  loaderContainer: {
    textAlign: "center",
    color: "#BE0A00",
    alignItems: "center",
    backgroundColor: "",
    display: "flex",
    justifyContent: "center",
    height: "20vh",
  },
}));
const AirFilter = () => {
  const classes = useStyles();
  const [airFilterData, setAirFilterData] = useState([]);
  const [loader, setLoader] = useState(false);
  useEffect(() => {
    console.log("rendered");
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    getAirFilterDetails();
  }, []);
  console.log('....', airFilterData);
  const getAirFilterDetails = async () => {
    setLoader(true);
    try {
      const resp = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/getProducts/${2}`,
        {
          method: "GET",
          headers: {
            // // "ngrok-skip-browser-warning": "true",
          },
        }
      );
      const data = await resp.json();
      //   console.log(data);
      setAirFilterData(data);
      setApiData(data)
      setLoader(false);
    } catch (e) {
      console.log(e);
      setLoader(false);
    }
  };

  // for pegination set pegination count and data
  let [page, setPage] = useState(1);
  const PER_PAGE = 10;

  const count = Math.ceil(airFilterData.length / PER_PAGE);
  const _DATA = usePagination(airFilterData, PER_PAGE);

  const [FilterKey, setFilterKey] = useState('')
  const [apiData, setApiData] = useState([])


  console.log("_DATA", _DATA.currentData());

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        {/* <title>My Title</title> */}
        <meta name="keywords" content="Automotive Engine Air filters manufacturer, Reliable Engine Air filter supplier" />
        <meta
          name="description"
          content="Breathe clean and maximize engine performance with our premium engine air filters. Our automotive air filters effectively capture dust, dirt, and other particles, ensuring optimal airflow and engine protection. Count on our ISO-certified manufacturing and superior quality for superior filtration. Browse our engine air filters for enhanced engine performance today."
        />
      </Helmet>
      <Header />
      <Container>
        <div className={classes.container}>
          <div>
            {/* <div
              style={{
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
              }}
            > */}
            {/* <div className={classes.filterHeader}>Air Filter</div> */}
            <div
                style={{
                  width: "100%",
                  height: "10%",
                  backgroundColor: "black",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                {/*<div
                  style={{
                    justifyContent: "center",
                    alignItems: "center",
                    width: "60%",
                  }}
                >
                  {" "}
                  <p style={{ color: "white", fontSize: "50px" }}>Air Filter</p>
                </div>*/}
                {/*<img
                  src={airFilter}
                  style={{ width: "40%", height: "100%", objectFit: "contain" }}
                />*/}
              </div>
            {/* </div>  */}

            <div className={classes.filterContent}>
              <p>
                {" "}
                Discover the leading engine air filter manufacturer offering
                top-of-the-line filtration solutions for optimal engine
                performance. Our advanced engine air filters are designed to
                efficiently capture and prevent harmful contaminants, such as
                dust, dirt, pollen, and debris, from entering your engine. With
                our state-of-the-art manufacturing facilities and cutting-edge
                technology, we ensure superior filtration and airflow, promoting
                better fuel efficiency and prolonging the life of your engine.
                Whether you have a car, truck, or SUV, our wide range of engine
                air filters is tailored to fit various makes and models,
                providing a perfect fit and easy installation. Trust in our
                expertise and industry-leading quality to keep your engine
                running smoothly and breathe cleaner air.
              </p>
              <p>
                Choose our engine air filters for unmatched reliability,
                durability, and performance. With access to the highest quality
                media from local and global suppliers we can make air filters to
                client's specifications at a competitive price. Review our list
                below.
              </p>
            </div>
            <div
              style={{
                width: "100%",
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
              }}
            >
              <TextField
                fullWidth
                id="standard-bare"
                variant="outlined"

                label="Air Filter"
                onChange={(e) => {
                  setFilterKey(e.target.value);
                  // var a=apiData.filter((item,id)=>(((item.part_no).toLowerCase()).includes(e.target.value.toLowerCase())))
                  var a = apiData.filter((item, id) => (((item.part_no).toLowerCase()).includes(e.target.value.toLowerCase()) || ((item.brand_no.replace(',', ' ')).toLowerCase()).includes(e.target.value.toLowerCase())))
                  setAirFilterData(apiData)
                  // _DATA=apiData
                  setPage(1)
                  _DATA.jump(1)
                  if (e.target.value == '') {
                    setAirFilterData(apiData)
                    // _DATA=[apiData]
                  }
                  else if (e.target.value != '' && a.length > 0) {
                    setAirFilterData(a)
                  }
                  else if (a.length <= 0) {
                    setAirFilterData([])
                  }

                }}
                InputProps={{
                  endAdornment: (
                    <IconButton>
                      <SearchOutlined />
                    </IconButton>
                  ),
                }}
              />
            </div>
            <Container maxWidth="md">
              <Box marginTop={5}>
                {loader === true && (
                  <Box className={classes.loaderContainer}>
                    <CircularProgress color="inherit" />
                  </Box>
                )}
                {loader === false && airFilterData.length === 0 && (
                  <Typography style={{ textAlign: "center" }}>
                    NO DATA AVAILABLE
                  </Typography>
                )}
                {loader === false && _DATA.currentData().length !== 0 && (
                  <>
                    {_DATA.currentData().map((value, index) => {
                      var brand;
                      var brandNo;
                      if (value.brand !== null) {
                        brand = value.brand.split(",");
                      }
                      if (value.brand_no !== null) {
                        brandNo = value.brand_no.split(",");
                      }
                      return (
                        <Box className={classes.elementContainer} key={index}>
                          <Box className={classes.imgBox}>
                            <img
                              // src={value.image_name}
                              src={`${process.env.REACT_APP_IMAGE_URL}/${value.image_name}`}
                              className={classes.img}
                              alt={value.part_no}
                              loading="lazy"
                            />
                          </Box>
                          <Grid container className={classes.gridWrapper}>
                            <Grid container className={classes.changeRowColor}>
                              <Grid
                                item
                                container
                                xs={4}
                                className={classes.gridList}
                                style={{ borderRight: "1px solid #ddd" }}
                              >
                                GPA#
                              </Grid>
                              <Grid
                                item
                                container
                                xs={8}
                                className={classes.gridList}
                              >
                                <b>{value.part_no}</b>
                              </Grid>
                            </Grid>
                            {brand.map((element, position) => (
                              <Grid
                                container
                                key={position}
                                className={classes.changeRowColor}
                              >
                                <Grid
                                  item
                                  container
                                  xs={4}
                                  className={classes.gridList}
                                  style={{ borderRight: "1px solid #ddd" }}
                                >
                                  {element}
                                </Grid>
                                <Grid
                                  item
                                  container
                                  xs={8}
                                  className={classes.gridList}
                                >
                                  {brandNo[position]}
                                </Grid>
                              </Grid>
                            ))}
                            <Grid container className={classes.changeRowColor}>
                              <Grid
                                item
                                container
                                xs={4}
                                className={classes.gridList}
                                style={{ borderRight: "1px solid #ddd" }}
                              >
                                APPLICATION
                              </Grid>
                              <Grid
                                item
                                container
                                xs={8}
                                className={classes.gridList}
                              >
                                {value.application}
                              </Grid>
                            </Grid>
                          </Grid>
                        </Box>
                      );
                    })}

                    <Box display="flex" justifyContent="center">
                      <Pagination
                        count={count}
                        page={page}
                        onChange={handleChange}
                      />
                    </Box>
                  </>
                )}
              </Box>
            </Container>
          </div>
        </div>
      </Container>
      <Footer />
    </>
  );
};
export default AirFilter;
